import React, { useEffect, useState } from 'react';
import { Box, Heading, Text, Button, Flex, useToast } from '@chakra-ui/react';
import { QRCodeCanvas } from 'qrcode.react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const QRLoginPage = () => {
  const [qrValue, setQrValue] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    const fetchLatestUser = async () => {
      try {
        const response = await axios.post('https://ssi-auth-backend.staging.trustgrid.com/login');


        const user = response.data;
        if (user) {
          const qrValue = JSON.stringify(user);
          setQrValue(qrValue);


          toast({
            title: 'Generated QR successfully.',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
        } else {
          setError('No user data received. Please register first.');
        }
      } catch (err) {
        console.error('Error fetching user:', err);
        setError('Failed to fetch user. Please try again.');
      }
    };

    fetchLatestUser();
  }, [toast]);

  return (
    <Flex justify="center" align="center" minH="100vh" bg="gray.50" p={4}>
      <Box bg="white" p={8} rounded="md" shadow="md" w="full" maxW="md" textAlign="center">
        <Heading mb={4} fontSize="2xl" color="blue.600">
          Login via QR
        </Heading>

        {error ? (
          <Text color="red.500">{error}</Text>
        ) : qrValue ? (
          <>
            <Text mb={4} color="gray.600">
              Scan this QR with your phone or another device to log in.
            </Text>
            <Flex justify="center">
  <Box display="inline-block" border="1px solid #E2E8F0" rounded="md" p={2}>
    <QRCodeCanvas value={qrValue} size={200} />
  </Box>
</Flex>

          </>
        ) : (
          <Text color="gray.500">Loading...</Text>
        )}

        <Button
          onClick={() => navigate('/')}
          variant="link"
          mt={6}
          colorScheme="blue"
        >
          ← Back to Home
        </Button>
      </Box>
    </Flex>
  );
};

export default QRLoginPage;
